import { all, call, put, takeLatest } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import AssetManagementApiService from './AssetManagementApiService'
import { GET_CATALOG_ITEM, GET_CATALOG_SPECIFICATION_BY_SUBTYPE, GET_IS_CATALOG_ITEM_VALID_DELETE, GET_IS_EQ_CLASS_VALID_DELETE, GET_IS_VEHICLE_LEVEL_VALID_DELETE, GET_SAVE_MULTIPLE_CATALOG_STATUS } from '../../Store/AssetManagement/CatalogItem/CatalogItemType'
import { setCatalogItem, setCatalogSpecificationBySubType, setIsCatalogItemValidDelete, setIsEqClassValidDelete, setIsVehicleLevelValidDelete, setSaveMultipleCatalogStatus } from 'Store/AssetManagement/CatalogItem/CatalogItemAction';
import RequisitionAction from 'Store/Component/Requisition/RequisitionAction'
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';

function* getCatalogItem(val: any): any {
    let payloadData : IPayload= {
        apiType : apiType.AssetManagement,
        endpoint : `assets/managedequipment/catalogitems`,
        apiMethod : apiMethod.POST,
        payload : val.filterValues
    }
    try {
        yield put(globalLoaderText("Fetching CatalogItem...."));

        const response = yield call(
            AssetManagementApiService.post,API_URL.PostWebApp,payloadData
            
        );
        if(response?.length > 0){
            yield put(setCatalogItem(response))
            yield put(RequisitionAction.setIsCatalogItemExist(true))
        } else {
            yield put (setCatalogItem([]))
            yield put(RequisitionAction.setIsCatalogItemExist(false))
        }
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogItem([]))
        yield put(RequisitionAction.setIsCatalogItemExist(false))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogSpecificationBySubType(val: any): any {
    try {
        yield put(globalLoaderText("Fetching CatalogItem...."));
        let payloadData : IPayload= {
            apiType : apiType.AssetManagement,
            endpoint : `assets/vehiclemanagedequipment/catalogspecification/${val.requestDetailId}?isBulkOrder=${val?.isBulkOrder}`,
            apiMethod :  apiMethod.POST,
            payload : null
        }
        const response = yield call(
            AssetManagementApiService.post,API_URL.PostWebApp,payloadData
           
        );
        if(response?.length > 0){
            yield put(setCatalogSpecificationBySubType({response, fleetId: val.fleetId}))
        } else {
            yield put (setCatalogSpecificationBySubType({response: [], fleetId: val.fleetId}))
        }
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogSpecificationBySubType({response: [], fleetId: val.fleetId}))
        yield put(globalLoaderText(""));
    }
}

function* getIsCatalogItemDeletedSaga(val: any): any {
    try {
        yield put(globalLoaderText("Validating Delete...."));
        let payloadData : IPayload= {
            apiType : apiType.AssetManagement,
            endpoint : `catalog/attribute/validateDelete`,
            apiMethod : apiMethod.POST,
            payload : val.payload
        }
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setIsCatalogItemValidDelete(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setIsCatalogItemValidDelete('error'))
        yield put(globalLoaderText(""));
    }
}

function* getIsVehicleLevelValidDeleteSaga(val: any): any {
    try {
        yield put(globalLoaderText("Validating Delete...."));
        let payloadData : IPayload= {
            apiType : apiType.AssetManagement,
            endpoint : `catalog/vehiclelevel/validateDelete`,
            apiMethod : apiMethod.POST,
            payload : val.payload
        }
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setIsVehicleLevelValidDelete(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setIsVehicleLevelValidDelete('error'))
        yield put(globalLoaderText(""));
    }
}

function* getIsEqClassValidDeleteSaga(val: any): any {
    try {
        yield put(globalLoaderText("Validating Delete...."));
        let payloadData : IPayload= {
            apiType : apiType.AssetManagement,
            endpoint : `catalog/eqclasscode/validateDelete`,
            apiMethod : apiMethod.POST,
            payload : val.payload
        }
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setIsEqClassValidDelete(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setIsEqClassValidDelete('error'))
        yield put(globalLoaderText(""));
    }
}

function* getSaveMultipleCatalogStatus(val: any): any {
    try {
        yield put(globalLoaderText("Changing Status...."));
        let payloadData : IPayload= {
            apiType : apiType.AssetManagement,
            endpoint : `assets/updateIsActiveByIds`,
            apiMethod : apiMethod.POST,
            payload : val.payload
        }
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setSaveMultipleCatalogStatus(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setSaveMultipleCatalogStatus(false))
        yield put(globalLoaderText(""));
    }
}

function* watchGetCatalogItem() {
    yield takeLatest(GET_CATALOG_ITEM, getCatalogItem)
    yield takeLatest(GET_CATALOG_SPECIFICATION_BY_SUBTYPE, getCatalogSpecificationBySubType)
    yield takeLatest(GET_IS_CATALOG_ITEM_VALID_DELETE, getIsCatalogItemDeletedSaga)
    yield takeLatest(GET_IS_VEHICLE_LEVEL_VALID_DELETE, getIsVehicleLevelValidDeleteSaga)
    yield takeLatest(GET_IS_EQ_CLASS_VALID_DELETE, getIsEqClassValidDeleteSaga)
    yield takeLatest(GET_SAVE_MULTIPLE_CATALOG_STATUS, getSaveMultipleCatalogStatus)
}

export default function* combinedSaga() {
    yield all([
        watchGetCatalogItem()
    ])
}
